import { render, staticRenderFns } from "./CourseCenter.vue?vue&type=template&id=27955dfb&scoped=true&"
import script from "./CourseCenter.vue?vue&type=script&lang=js&"
export * from "./CourseCenter.vue?vue&type=script&lang=js&"
import style0 from "./CourseCenter.vue?vue&type=style&index=0&id=27955dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27955dfb",
  null
  
)

export default component.exports